import { Route } from '@angular/router';

export const attendanceRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./list/attendance-list.component').then(
            (m) => m.AttendanceListComponent
          ),
      },
      {
        path: 'reports',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './reports/switchboard/attendance-reports-switchboard.component'
              ).then((m) => m.AttendanceReportsSwitchboardComponent),
          },
          {
            path: 'daily-summary',
            loadComponent: () =>
              import(
                './reports/daily-summary-report/daily-summary-report.component'
              ).then((m) => m.DailySummaryReportComponent),
          },
          {
            path: 'expert-history',
            loadComponent: () =>
              import(
                './reports/expert-history-report/expert-history-report.component'
              ).then((m) => m.ExpertHistoryReportComponent),
          },
          {
            path: 'expert-summary',
            loadComponent: () =>
              import(
                './reports/expert-summary-report/expert-summary-report.component'
              ).then((m) => m.ExpertSummaryReportComponent),
          },
          {
            path: 'expertise-analytics',
            loadComponent: () =>
              import(
                './reports/expertise-analytics/expertise-analytics-report.component'
              ).then((m) => m.ExpertiseAnalyticsReportComponent),
          },
          {
            path: 'time-analytics',
            loadComponent: () =>
              import(
                './reports/time-analytics-report/time-analytics-report.component'
              ).then((m) => m.TimeAnalyticsReportComponent),
          },
          {
            path: 'location-based',
            loadComponent: () =>
              import(
                './reports/location-based-analytics/location-based-report.component'
              ).then((m) => m.LocationBasedReportComponent),
          },
          {
            path: 'active-sessions',
            loadComponent: () =>
              import(
                './reports/active-sessions-report/active-sessions-report.component'
              ).then((m) => m.ActiveSessionsReportComponent),
          },
          {
            path: 'expert-detailed-attendance',
            loadComponent: () =>
              import(
                './reports/expert-detailed-attendance-report/expert-detailed-attendance-report.component'
              ).then((m) => m.ExpertDetailedAttendanceReportComponent),
          },
        ],
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./detail/attendance-detail.component').then(
            (m) => m.AttendanceDetailComponent
          ),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import('./detail/attendance-detail.component').then(
            (m) => m.AttendanceDetailComponent
          ),
      },
    ],
  },
];
